import { DateTime } from 'luxon';
import type { IPrivateListing } from './mock-listings.data';

/** Mirrors the server's `LISTING_INCOMPLETE_ALLOWED_DAYS` (server/src/shared/constants.ts) —
 *  duplicated here since cnt-landing doesn't share code with server/. Keep in sync. */
const PHOTO_GRACE_PERIOD_DAYS = 30;
export const MINIMUM_REQUIRED_PHOTOS = 3;

/** True once a listing has been published (has a `publishDate`) but still has fewer
 *  than the required photo count — the state the 30-day grace period applies to. */
export function photosIncomplete(listing: Pick<IPrivateListing, 'images' | 'publishDate'>): boolean {
  return !!listing.publishDate && (listing.images?.length ?? 0) < MINIMUM_REQUIRED_PHOTOS;
}

/** Days left before the server disables the listing for missing photos, counting
 *  down from `publishDate + PHOTO_GRACE_PERIOD_DAYS`. 0 once the window has passed. */
export function photoGraceDaysRemaining(listing: Pick<IPrivateListing, 'publishDate'>): number {
  if (!listing.publishDate) return 0;
  return Math.max(
    0,
    Math.round(DateTime.fromSeconds(listing.publishDate).plus({ days: PHOTO_GRACE_PERIOD_DAYS }).diffNow('days').days),
  );
}
